import { render } from "./AutoWidthOption.vue?vue&type=template&id=7ac745b9"
import script from "./AutoWidthOption.vue?vue&type=script&lang=ts"
export * from "./AutoWidthOption.vue?vue&type=script&lang=ts"
script.render = render

export default script